/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';

import FilePickerDialog from 'components/forms/FilePickerDialog';
import {Button} from '@mui/material';
import ImportSubEventBody from './ImportSubEventBody';

export type ControlType = {
  name: string;
  type: string;
  position: {
    lat: number;
    lng: number;
  };
  id: number;
  siCode: number;
};

export type SubEventType = {
  name: string;
  controls: ControlType[];
};

const ImportSubEventsButtonJSON = () => {
  const [subEvents, setSubEvents] = useState<SubEventType[]>([]);
  const [allControls, setAllControls] = useState<ControlType[]>([]);

  const handleFileChange = (jsonString: string) => {
    try {
      const data = JSON.parse(jsonString);
      const controls: {[keys: string]: ControlType} = {};

      const subEvents = data.map((subEvent: any) => {
        const subEventControls = subEvent.controls.map(({control}: any) => {
          return {
            name: control.code,
            type: 'default',
            position: {
              lat: control.position.latitude,
              lng: control.position.longitude
            },
            id: parseInt(control.code) || 0,
            siCode: parseInt(control.code) || 0
          };
        });
        subEventControls.forEach((control: ControlType) => {
          controls[control.name] = control;
        });
        return {
          name: subEvent.name,
          controls: subEventControls
        };
      });
      setAllControls(Object.values(controls));
      setSubEvents(subEvents);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <FilePickerDialog
        label="JSON"
        variant="text"
        accept=".json"
        extension="json"
        handleFileChange={handleFileChange}
        fullWidth={false}
        primaryButton={
          <Button type="submit" form="import_sub_events" variant="contained">
            Create
          </Button>
        }
      >
        <ImportSubEventBody controls={allControls} subEvents={subEvents} />
      </FilePickerDialog>
    </React.Fragment>
  );
};

export default ImportSubEventsButtonJSON;
